import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { getValidationClass } from '@/utils/formUtils';
import FormError from '@/components/common/form/FormError';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './PasswordField.module.scss';
import { ERROR_TYPE, FIELD_TYPE } from '@/constants/form';
import { URLS } from '@/constants/urls';

const PasswordField = ({
  id, name, className, isRequired, minLength, validators = [], ...rest
}) => {
  const { register, getValues, formState, formState: { errors } } = useFormContext();
  const [isPwdVisible, setIsPwdVisible] = useState(false);

  const changePasswordVisibility = () => {
    setIsPwdVisible(!isPwdVisible);
  };

  const checkPasswordConfirm = (confirm) => {
    if (getValues('password') !== confirm) {
      return 'forms.errors.confirmNotMatchPassword';
    }

    return true;
  };

  const validate = Object.fromEntries([
    validators.includes(ERROR_TYPE.CONFIRM) && [ERROR_TYPE.CONFIRM, checkPasswordConfirm]
  ].filter(Boolean));

  const inputProps = {
    id,
    rbf: `input${id ? '-' + id : ''}`,
    ...register(name, {
      required: isRequired,
      validate,
      minLength: { value: minLength, message: 'forms.errors.passwordTooShort' }
    }),
    className: [
      'form-control',
      className,
      getValidationClass(name, formState)
    ].filter(Boolean).join(' '),
    ...rest
  };

  return (
    <>
      <div className="input-group">
        <input {...inputProps} type={isPwdVisible ? FIELD_TYPE.TEXT : FIELD_TYPE.PASSWORD} />
        <div className={`${styles['visibility-button']} input-group-append`} onClick={changePasswordVisibility}>
          <span className={`${styles.icon} input-group-text`}>
            <Icon
              src={isPwdVisible ? URLS.ICON_HIDDEN : URLS.ICON_VIEW}
              alt={isPwdVisible ? 'hidden' : 'view'}
              height={20}
              width={20}
            />
          </span>
        </div>
      </div>

      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

PasswordField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  minLength: PropTypes.number,
  validators: PropTypes.arrayOf(PropTypes.string)
};

export default PasswordField;
